import * as React from 'react';
import ContentLoader from 'react-content-loader';

// Use http://danilowoz.com/create-content-loader/ to create
// custom content loader layouts easily.
const SiteCardContentLoader = (): JSX.Element => (
    <ContentLoader height={128} width={360} speed={2} color="#f3f3f3" style={{ height: '128px' }}>
        <rect x="68" y="17" rx="2" ry="2" width="70" height="20" />
        <circle cx="29" cy="27" r="12" />
        <rect x="68" y="54" rx="2" ry="2" width="70" height="20" />
        <circle cx="29" cy="64" r="12" />
        <rect x="68" y="90" rx="2" ry="2" width="70" height="20" />
        <circle cx="29" cy="100" r="12" />
        <circle cx="212" cy="42" r="22" />
        <rect x="187" y="68" rx="2" ry="2" width="51" height="16" />
        <rect x="170" y="88" rx="2" ry="2" width="88" height="16" />
        <circle cx="305" cy="42" r="22" />
        <rect x="280" y="68" rx="2" ry="2" width="51" height="16" />
        <rect x="263" y="88" rx="2" ry="2" width="88" height="16" />
    </ContentLoader>
);

export { SiteCardContentLoader };
